import { Link } from "react-router-dom";
import { Phone, Mail, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/anim/Reveal";

const CTASection = () => {
  return (
    <section className="fs-section relative" data-testid="cta-section">
      <div className="fs-grid-bg" />
      <div className="fs-container">
        <Reveal>
          <div
            className="relative rounded-2xl p-10 md:p-14 overflow-hidden"
            style={{
              background:
                "linear-gradient(160deg, rgba(15,34,66,0.75), rgba(9,20,40,0.75))",
              border: "1px solid rgba(77,215,238,0.22)",
              boxShadow: "0 40px 100px -30px rgba(77,215,238,0.25)",
            }}
          >
            {/* glow */}
            <div
              className="absolute -top-20 -left-20 w-96 h-96 rounded-full pointer-events-none"
              style={{ background: "radial-gradient(closest-side, rgba(77,215,238,0.18), transparent)" }}
            />
            <div
              className="absolute -bottom-24 -right-16 w-96 h-96 rounded-full pointer-events-none"
              style={{ background: "radial-gradient(closest-side, rgba(77,215,238,0.14), transparent)" }}
            />

            <div className="fs-eyebrow mb-4">Let's Talk</div>
            <h2 className="fs-heading text-4xl md:text-5xl max-w-3xl">
              Let's Build Your <span className="fs-gradient-text">Business Communication Infrastructure</span>
            </h2>
            <p className="mt-5 text-[color:var(--text-dim)] max-w-2xl leading-relaxed">
              From carrier-grade connectivity to cloud telephony, contact centres
              and cyber security — talk to a Four Square specialist and get a
              tailored blueprint for your enterprise.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <a href="tel:+918681833444" className="fs-btn-primary" data-testid="cta-call">
                <Phone size={16} /> Call Now
              </a>
              <a
                href="mailto:connect@foursquareinfo.com"
                className="fs-btn-outline-soft"
                data-testid="cta-email"
              >
                <Mail size={16} /> Email Us
              </a>
              <Link to="/contact" className="fs-btn-ghost" data-testid="cta-consult">
                Request a Consultation <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CTASection;
